<template>
  <div class="sequence-creator-page">
    <div class="sequence-creator-page-sidebar">
      <SequenceBrowser />
    </div>
    <div class="sequence-creator-page-content">
      <router-view ref="view" :key="$route.params.sequenceId"></router-view>
      <div v-if="$route.params.sequenceId === undefined">
        <p class="no-content">
          No routine selected.<br />
          Please select a routine from the menu or create a new one.
        </p>
      </div>
    </div>
    <!-- <template v-if="$route.name === 'sequence_creator'">
      <div class="card m-2 p-4" style="width:auto"></div>
    </template>
    <template v-else>
      <el-card></el-card>
    </template> -->
  </div>
</template>

<script>
import SequenceBrowser from '@/components/RoutineCreatorPage/SequenceBrowser'

export default {
  name: "SequenceCreatorPage",
  data: () => ({
  }),
  beforeRouteUpdate (to, from, next) {
    if ( this.$refs.view && this.$refs.view.document_dirty ) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (!answer) {
        console.log("CANCEL NAVIGATION");
        next(false)
      }
    }
    next()
  },
  computed: {
  },
  methods: {
  },
  components: {
    SequenceBrowser
  }
};
</script>

<style>
.sequence-creator-page {
  display: flex;
  min-height: 100vh;
}
.sequence-creator-page .sequence-creator-page-sidebar {
  width: 250px;
  flex: 0 0 250px;
  border-right: 1px solid grey;
}
.sequence-creator-page .sequence-creator-page-content {
  width: 100%;
}
/*
.sequence-creator-page .no-content {
  text-align: center;
  margin: 15em auto;
  color: #BFBFBF;
  font-size: 110%;
  font-weight: bold;
}
*/
</style>
